import { state } from '@/manager/payment/store/state';
import { getters } from '@/manager/payment/store/getters';
import { mutations } from '@/manager/payment/store/mutations';
import { actions } from '@/manager/payment/store/action';

export const payment = {
    state,
    getters,
    actions,
    mutations,
};
